module.exports = __webpack_public_path__ + "static/img/main_visual_tb.d38ad78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main_visual_tb.jpg
// module id = 0+1S
// module chunks = 34